const errorMessages = {
    category_input_invalid: ['Please select valid Google categories before requesting suggestions.', 'Bitte wählen Sie gültige Google-Kategorien aus, bevor Sie Vorschläge anfordern.'],
    category_ai_quota: ['AI category suggestions have reached their usage limit. Please try again later.', 'Das Nutzungslimit für KI-Kategorievorschläge ist erreicht. Bitte versuchen Sie es später erneut.'],
    category_ai_unavailable: ['AI category suggestions are currently unavailable. Please try again.', 'KI-Kategorievorschläge sind derzeit nicht verfügbar. Bitte versuchen Sie es erneut.'],
    category_ai_timeout: ['The category suggestion request timed out. Please try again.', 'Die Anfrage für Kategorievorschläge hat zu lange gedauert. Bitte versuchen Sie es erneut.'],
    category_ai_configuration: ['AI category suggestions are not configured correctly. Please contact support.', 'KI-Kategorievorschläge sind nicht korrekt eingerichtet. Bitte kontaktieren Sie den Support.'],
    category_ai_invalid_response: ['No valid category suggestions were received. Please try again.', 'Es wurden keine gültigen Kategorievorschläge empfangen. Bitte versuchen Sie es erneut.'],
    category_catalog_unavailable: ['The category catalog is currently unavailable. Please try again later.', 'Der Kategorienkatalog ist derzeit nicht verfügbar. Bitte versuchen Sie es später erneut.'],
    category_primary_required: ['Please select a primary category before requesting suggestions.', 'Bitte wählen Sie eine Hauptkategorie aus, bevor Sie Vorschläge anfordern.']
};

export function categorySuggestionMessage(code, language) {
    const messages = Object.prototype.hasOwnProperty.call(errorMessages, code)
        ? errorMessages[code] : errorMessages.category_ai_invalid_response;
    return messages[String(language || '').toLowerCase().startsWith('de') ? 1 : 0];
}

export function categorySuggestionError(code) {
    const safeCode = Object.prototype.hasOwnProperty.call(errorMessages, code)
        ? code : 'category_ai_invalid_response';
    return {
        success: false,
        error_code: safeCode,
        message: categorySuggestionMessage(safeCode, 'en'),
        data: null
    };
}

export function hasPrimaryCategory(category) {
    return !!category && typeof category.name === 'string' && category.name.trim().length > 0;
}

export function isCategorySuggestionData(data) {
    const isCategory = (category) => hasPrimaryCategory(category) &&
        typeof category.displayName === 'string' && category.displayName.trim().length > 0;
    return !!data && !Array.isArray(data) && isCategory(data.primaryCategory) &&
        Array.isArray(data.additionalCategories) &&
        data.additionalCategories.every(isCategory);
}

// Only accept the category endpoint's domain envelope; never display raw provider errors.
export function normalizeCategorySuggestionResponse(response) {
    if (response === false) {
        return categorySuggestionError('category_ai_unavailable');
    }
    if (response?.success === true && isCategorySuggestionData(response.data)) {
        return {success: true, data: response.data};
    }
    if (response?.success === false) {
        return categorySuggestionError(response.error_code);
    }
    return categorySuggestionError('category_ai_invalid_response');
}
